<template>
  <div class="productInfoBox">
    <div class="productInfoMain">
      <!-- 订单详情 -->
      <section class="productInfoTitle">
        <span>{{ $t("productInfo.orderDetail") }}</span>
      </section>
      <div
        class="productInfoState"
        v-if="productInfo.State"
      >
      <div>{{ $t("productInfo.currentState") }}：{{productInfo.State | stateStrFilter(productInfo.State)}}</div>
      <div v-if="productInfo.OrderCancelReason">{{ $t("productInfo.closeReason") }}：{{productInfo.OrderCancelReason}}</div>
      </div>
      <!-- 切换订单信息与物流信息 -->
      <ul class="stateList">
        <li :class="[state==0?'stateItemAc':'stateItem']" @click="changeStata(0)">{{ $t("productInfo.tab1") }}</li>
        <li :class="[state==1?'stateItemAc':'stateItem']" @click="changeStata(1)">{{ $t("productInfo.tab2") }}</li>
      </ul>
      <!-- 订单信息 -->
      <div class="productInfoBody" v-if="state==0">
        <!-- 买家信息 -->
        <div class="buyerInfo">
          <p class="buyerInfoTitle">{{ $t("productInfo.buyInfo") }}</p>
          <section class="buyerInfoUserBox">
            <p class="buyerInfoName">{{ $t("productInfo.receivingName") }}：{{productInfo.ReceivingName}}</p>
            <p class="buyerInfoPhone">{{ $t("productInfo.phoneNumber") }}：{{productInfo.PhoneNumber}}</p>
          </section>
          <div class="buyerInfoAdress">{{ $t("productInfo.receivingAddress") }}：{{productInfo.ReceivingAddress}}</div>
        </div>
        <!-- 订单号详情 -->
        <div class="productNumInfo">
          <p class="productNumInfoTitle">{{ $t("productInfo.orderDetail") }}</p>
          <section class="productNumBox">
            <p class="productNum">{{ $t("productInfo.orderNumber") }}：{{productInfo.OrderNumber}}</p>
            <p class="productFlowNum">{{ $t("productInfo.payNumber") }}：{{productInfo.PayNumber}}</p>
            <p class="productCteateTime">{{ $t("productInfo.createTime") }}：{{productInfo.CreateTime}}</p>
          </section>
          <p class="productPayTime">{{ $t("productInfo.payTime") }}：{{productInfo.PayTime}}</p>
        </div>
        <!-- 订单商品信息 -->
        <order-shop :productInfo="productInfo" />
      </div>
      <!-- 物流信息 -->
      <div class="logisticsBox" v-else>
        <!-- <h3>物流状态：{{productInfo.State | stateStrFilter(productInfo.State)}}</h3> -->
        <el-timeline v-if="logisticsData.length" :reverse="reverse">
          <el-timeline-item
            v-for="(activity, index) in logisticsData"
            :key="index"
            :timestamp="activity.CreateTime"
            :color="activity.color"
          >{{activity.LStateStr}}</el-timeline-item>
        </el-timeline>
        <h3 v-else style="text-align:center">{{ $t("productInfo.noLogistics") }}</h3>
      </div>
    </div>
  </div>
</template>
<script>
import OrderShop from './components/OrderShop'
export default {
  name: 'ProductInfo',
  components: {
    OrderShop
  },
  data () {
    return {
      reverse: true,
      productInfo: {}, // 订单详情
      state: 0, // 状态0为订单信息1为物流信息
      orderNumber: null, // 订单号,
      logisticsData: []
    }
  },
  created () {
    let { orderNumber } = this.$route.query;
    (orderNumber) && (this.orderNumber = orderNumber)
  },
  mounted () {
    this.getLoadOrderInfo()
  },
  methods: {
    getLoadOrderInfo () {
      
      // this.orderNumber ? this.orderNumber : '202005210529811'
      let param = {
        OrderNumber: this.orderNumber,
        CustomerId: JSON.parse(localStorage.getItem('supplierInfo')).CustomerId
      }
      console.log(123)
      this.$api.order.loadOrderInfo(param).then(res => {
        this.productInfo = res.data
        
        console.log(res)
      }).catch(error => {
        
        this.$message.error(error.message)
      })
    },
    // 获取物流详情
    getOrderLogistics () {
      let param = {
        OrderNumber: this.orderNumber,
        Language:"ZH"
      }
      this.$api.order.loadOrderLogistics(param).then(res => {
        console.log(res,'res');
       if(res.data !==null){
          res.data[res.data.length - 1].color = '#0bbd87'
        this.logisticsData = res.data
       }else{
         this.logisticsData = []
       }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 修改状态
    changeStata (newState) {
      console.log(newState);
      (newState !== this.state) && (this.state = newState)
      if (newState == 1) {
        this.getOrderLogistics()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.productInfoBox {
  position: relative;
  width: 100%;
  border-radius: 7px;
  -webkit-box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
  min-width: 720px;
  .productInfoMain {
    padding: 30px 20px;
    box-sizing: border-box;
    .productInfoTitle {
      color: #000000;
      font-size: 14px;
      font-weight: bold;
    }
    // 订单状态
    .productInfoState {
      padding: 0 38px;
      border-radius: 9px;
      // line-height: 80px;
      height: 80px;
      color: #000000;
      font-size: 12px;
      background-color: #d9ebe7;
      margin-top: 26px;
      margin-bottom: 14px;
      div{
        height: 40px;
        line-height: 40px;
      }
    }
    .stateList {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      font-size: 13px;
      .stateItem {
        text-align: center;
        list-style: none;
        margin: 0;
        padding: 26px 38px;
        border-bottom: 4px solid #ffffff;
        color: #000000;
      }
      .stateItemAc {
        text-align: center;
        list-style: none;
        padding: 26px 38px;
        color: #22b196;
        border-bottom: 4px solid #22b196;
      }
      li {
        cursor: pointer;
      }
    }
    .productInfoBody {
      position: relative;
      // 买家信息
      .buyerInfo {
        margin-left: 22px;
        font-size: 13px;
        margin-top: 32px;
        .buyerInfoTitle {
          margin: 0;
          padding: 0;
        }
        .buyerInfoUserBox {
          display: flex;
          align-items: center;
          margin-top: 18px;
          .buyerInfoName {
            margin: 0;
            padding: 0;
            margin-right: 12rem;
          }
          .buyerInfoPhone {
            margin: 0;
            padding: 0;
          }
        }
        .buyerInfoAdress {
          margin-top: 12px;
        }
      }
      //订单号信息
      .productNumInfo {
        font-size: 13px;
        color: #333333;
        background-color: #f0f0f0;
        border-radius: 7px;
        padding: 20px 24px;
        box-sizing: border-box;
        margin-top: 20px;
        .productNumInfoTitle {
          margin: 0;
          padding: 0;
        }
        .productNumBox {
          margin-top: 18px;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          .productNum,
          .productFlowNum,
          .productCteateTime {
            margin: 0;
            padding: 0;
          }
          .productFlowNum {
            margin-left: 98px;
            margin-right: 48px;
          }
        }
        .productPayTime {
          margin: 0;
          padding: 0;
        }
      }
    }
    .logisticsBox {
      padding: 30px 50px;
      box-sizing: border-box;
      // text-align: center;
      ::v-deep.el-timeline-item__wrapper {
        padding-left: 50px;
      }
    }
  }
}
</style>
